import {
  SlInclude
} from "./chunk.5H57EOKC.js";

// src/components/include/include.ts
var include_default = SlInclude;
SlInclude.define("sl-include");

export {
  include_default
};
